import React, { useEffect, useState } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from "recharts";
import "../css/TaxSavingsCalculator.css";

const TaxSavingsCalculator = () => {
  const [years, setYears] = useState(30);
  const [portfolioValue, setPortfolioValue] = useState(500000);
  const [taxRate, setTaxRate] = useState(35); // % input
  const [returnNoOpt, setReturnNoOpt] = useState(10); // Editable base return
  const returnManual = 10.8;
  const returnAuto = 11.6;

  const [data, setData] = useState([]);

  useEffect(() => {
    calculateGrowth();
  }, [years, portfolioValue, taxRate, returnNoOpt]);

  const calculateGrowth = () => {
    let valueNoOpt = portfolioValue;
    let valueManual = portfolioValue;
    let valueAuto = portfolioValue;

    const dataPoints = [];

    const taxDecimal = taxRate / 100;
    const noOptRate = returnNoOpt / 100;
    const manualRate = returnManual / 100;
    const autoRate = returnAuto / 100;

    for (let i = 0; i <= years; i++) {
      dataPoints.push({
        year: new Date().getFullYear() + i,
        noOpt: Math.round(valueNoOpt),
        manualOpt: Math.round(valueManual),
        autoOpt: Math.round(valueAuto),
      });

      valueNoOpt *= 1 + noOptRate * (1 - taxDecimal);
      valueManual *= 1 + manualRate * (1 - taxDecimal);
      valueAuto *= 1 + autoRate * (1 - taxDecimal);
    }

    setData(dataPoints);
  };

  return (
    <div className="calculator-grid">
      <div className="input-container">
        <label>Portfolio Size ($)</label>
        <input
          type="number"
          value={portfolioValue}
          onChange={(e) => setPortfolioValue(+e.target.value)}
        />

        <label>Income Tax Bracket (%)</label>
        <input
          type="number"
          value={taxRate}
          onChange={(e) => setTaxRate(+e.target.value)}
        />

        <label>Projection Period (Years)</label>
        <input
          type="number"
          value={years}
          onChange={(e) => setYears(+e.target.value)}
        />

        <label>Approx. Annual Return (%)</label>
        <input
          type="number"
          value={returnNoOpt}
          onChange={(e) => setReturnNoOpt(+e.target.value)}
        />

        <label>Manual Tax Optimization Return (%)</label>
        <input type="number" value={returnManual} readOnly style={{ background: "#f5f5f5" }} />

        <label>Automated Tax Optimization Return (%)</label>
        <input type="number" value={returnAuto} readOnly style={{ background: "#f5f5f5" }} />
      </div>

      <div className="impact-dashboard">
        <h3>🏆 REAL RESULTS FROM OUR USERS</h3>
        
        <div className="impact-metrics">
          <div className="metric-card">
            <div className="metric-value">$2.4M+</div>
            <div className="metric-label">Total Tax Savings Generated</div>
          </div>
          
          <div className="metric-card">
            <div className="metric-value">$45,000</div>
            <div className="metric-label">Average Savings Per User</div>
          </div>
          
          <div className="metric-card">
            <div className="metric-value">1,200+</div>
            <div className="metric-label">Users Optimized</div>
          </div>
          
          <div className="metric-card">
            <div className="metric-value">$180K</div>
            <div className="metric-label">Highest Single User Savings</div>
          </div>
        </div>
        
        <div className="impact-summary">
          <p>
            <strong>Portfolio with No Tax Optimization:</strong>{" "}
            <span>${data[data.length - 1]?.noOpt.toLocaleString() || 0}</span>
          </p>
          <p>
            <strong>Portfolio with Manual Tax Optimization:</strong>{" "}
            <span>${data[data.length - 1]?.manualOpt.toLocaleString() || 0}</span>
          </p>
          <p>
            <strong>Portfolio with Automated Tax Optimization:</strong>{" "}
            <span>${data[data.length - 1]?.autoOpt.toLocaleString() || 0}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default TaxSavingsCalculator;
